import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { createScrollbarCss } from '@sternum/web/utils';

export const AppContainerWithMenuStyled = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.theme.layout.mainCollapsedMenuWidth}px 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: 'menu content';
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  transition: grid-template-columns ease-in-out 0.3s;

  &[data-is-full-menu-visible='true'] {
    grid-template-columns: ${(props) => props.theme.layout.mainFullMenuWidth}px 1fr;
  }

  &[data-is-category-dashboard-visible='true'] {
    grid-template-columns: ${(props) =>
        props.theme.layout.mainCollapsedMenuWidth + props.theme.layout.dashboardsMenuWidth}px 1fr;
  }
`;

export const MenuContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-area: menu;

  ${createScrollbarCss({
    Dark: { background: 'transparent', thumbBackground: Colors.Dark },
    Light: { background: 'transparent', thumbBackground: Colors.Dark },
  })}
`;

export const Content = styled.div`
  grid-area: content;
  overflow: auto;
`;
